import React from "react";
import { Editor } from "slate";
import { Plugin } from "slate-react";
import { BLOCKS } from "../html";
import { AddIsToggledQuery } from "./isToggled";
import { AddToggleCommand } from "./toggleCommand";

const { type } = BLOCKS.PARAGRAPH;

const isParagraph = (editor: Editor) => editor.value.blocks.some(block => block.type === type);

const toggleParagraph = (editor: Editor): Editor => {
  const newBlockType = isParagraph(editor) ? BLOCKS.PARAGRAPH.type : type;
  editor.setBlocks(newBlockType);
  return editor;
};

/**
 * Slate plugin to handle <p> tags
 */
export const Paragraph: Plugin[] = [
  AddIsToggledQuery(type, isParagraph),
  AddToggleCommand(type, toggleParagraph),
  {
    renderBlock: (props, controller, next) => {
      const { attributes, children, node } = props;
      if (node.type === BLOCKS.PARAGRAPH.type) {
        return (
          <p {...attributes} className={node.data.get("className")}>
            {children}
          </p>
        );
      }
      else {
        return next();
      }
    },
  },
];
